/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  commodity.ts
 * @Package :
 * @author:青瞳科技
 * @date:   2022/1/19 11:32
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 青瞳科技
 * 注意：本内容仅限于深圳青瞳科技有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

import {axiosAPIUrl, Parameter, assignParams} from "./index";
import {CustomerListDto} from "@/api/customerManage";
import { LevelListDto } from '@/api/customerManage'

// 商品列表信息
export class GoodsListDto{
    /* 关联编号 */
    relationId: string;
    /* 公司编号 */
    companyId: string;
    /* 公司名称 */
    companyName: string;
    /* 商品编号 */
    goodsId: string;
    /* 商品名称 */
    goodsName: string;
    /* 商品排序号 */
    goodsSortNum: string;
    /*  */
    sortNum: string;
    /* 品牌编号 */
    brandId: string;
    /* 图片地址 */
    imageUrl: string;
    /* 市场价 */
    marketPrice: string;
    /* 市场最低价 */
    marketPriceMin: string;
    /* 市场最高价 */
    marketPriceMax: string;
    /* 成本价 */
    referPrice: string;
    /* 最低成本价 */
    referPriceMin: string;
    /* 最高成本价 */
    referPriceMax: string;
    /*  商品状态(1:上架 2：下架 3：停用 4：删除)*/
    goodsStatus:string;
    /* 分类编号 */
    categoryId: string;
    /* 搜索关键字*/
    keyword: string;
    /* 创建时间 */
    createTime: string;
    /* 更新时间 */
    updateTime: string;
    /* 标签编号 */
    tagId: string;
    /* 商品标签名称 */
    tagName: string;
    /* 商品标签颜色 */
    tagColor: string;
    /* 商品品牌列表 */
    brandList:GoodsBrandListDto[];
    showMark?: boolean;
}
// 商品品牌列表信息
export class GoodsBrandListDto{
    /* 商品品牌编号 */
    brandId: string;
    /* 商品品牌名称 */
    brandName: string;
    /* 供应商编号 */
    providerId: string;
    /* 是否启用（0：未启用 1：已启用） */
    isUse: string;
    /* 创建人 */
    createUser: string;
    /* 创建时间 */
    createTime: string;
    /*更新人  */
    updateUser: string;
    /* 更新时间 */
    updateTime: string;
}
// 商品标签列表信息
export class GoodsTagListDto{
    /* 公司编号 */
    companyId: string;
    /* 商品标签编号 */
    tagId: string;
    /* 商品标签名称 */
    tagName: string;
    /* 商品标签颜色 */
    tagColor: string;
    /* 是否可修改 */
    isUpdate: string;

}
// 商品详情信息
export class GoodsInfoDto{
    /* 公司编号 */
    companyId: string;
    /* 商品编号 */
    goodsId: string;
    /* 商品名称 */
    goodsName: string;
    /* 商品编码 */
    goodsCode: string;
    /* 商品分类编号 */
    categoryId: string;
    /* 商品分类名称 */
    categoryName: string;
    /* 品牌编号 */
    brandId: string;
    /* 商品品牌名称 */
    brandName: string;
    /* 商品视频Url */
    videoUrl: string;
    /* HTML文件url */
    htmlUrl: string;
    /* 商品描述url */
    descriptionUrl: string;
    /* 市场价 */
    marketPrice: string;
    marketPriceMax:string;
    packageNameDesc:string;
    referPriceMax:string;
    /* 参考成本价 */
    referPrice: string;
    /* 条形码 */
    barcode: string;
    /* 重量 */
    weight: string;
    /* 商品描述内容 */
    descriptionContext: string;
    /* 图片Id */
    autoId: string;
    /* 序号 */
    serialNumber: string;
    /* 图片名称 */
    imageName: string;
    /* 图片url */
    imageUrl: string;
    /* 规格编号 */
    specificationId: string;
    /* 规格名称 */
    attrName: string;
    /* 规格值列表 */
    attrValues: string;
    /* 规格值编码列表 */
    attrValueCodes: string;
    /* 序号 */
    sortNum: string;
    /* 套餐编号 */
    packageId: string;
    /* 套餐编码 */
    packageCode: string;
    /* 价格设置是否同步至其他套餐 */
    isSyncOther: string;
    /* 价格设置是否同步至其他套餐 boolean */
    isSyncOtherBool: boolean;
    /* 套餐主图url */
    mainImageUrl: string;
    /* 套餐名 */
    packageName: string;
    /* 级别名称 */
    levelName: string;
    /* 客户级别编号 */
    customerLevelId: string;
    /* 订货折扣 */
    buyDiscount: string;
    /* 订货价 */
    orderPrice: string;
    /* 起订量 */
    minimum: string;
    /* 限定量 */
    maximum: string;
    /* 客户编号 */
    customerId: string;
    /* 客户名称（公司名称） */
    customerName: string;
    /* 搜索关键字*/
    keyword: string;
    /*套餐状态  */
    packageStatus: string;
    /* 商品标签编号 */
    tagId: string;
    /* 商品标签名称 */
    tagName: string;
    /* 商品标签颜色 */
    tagColor: string;
    goodsTagList: {
        tagColor?: string;
        tagId?: string;
        tagName?: string;
    }[];
    /* 是否可修改 */
    isUpdate: string;
    /* 是否为多规格 */
    isMultiSpec?: string;
    /* 商品图册 */
    goodsImageList?: ShopGoodsImgListDto[];
}

export class ShopGoodsImgListDto {
    autoId?: string;
    serialNumber?: number;
    imageName?: string;
    imageUrl?: string;
}
//新增商品
export class GoodsSubmitDto{
    /* 是否立即上架 */
    upRighNow: boolean;
    /* 公司编号 */
    companyId: string;
    /* 商品名称 */
    goodsName: string;
    /* 商品分类编号 */
    goodsCategoryId: string;
    /* 商品分类名称 */
    categoryName;
    /* 商品品牌编号 */
    goodsBrandId: string;
    /* 商品品牌名称 */
    brandName: string;
    /* 搜索关键字 */
    keyword: string;
    /* 商品编码 */
    goodsCode: string;
    /* 是否开启商品多规格(0:不开启,1:开启) */
    multiSpec: string;
    /* 商品视频文件名称 */
    goodsVideoName: string;
    /* 商品视频文件url */
    goodsVideoUrl: string;
    /* 商品视频文件大小 */
    goodsVideoSize: string;
    /*  商品描述文件url*/
    descriptionUrl: string;
    /* 商品描述内容 */
    descriptionContext: string;
    /* 商品描述文件size */
    descriptionSize: string;
    /* 商品标签编号 */
    goodsTagId: string;
    /* 规格编号 */
    specificationId: string;
    /* 规格名称 */
    attrName: string;
    /* 规格值 */
    attrValue: string;
    /* 规格值编码 */
    attrValueCode: string;
    /* 规格序号 */
    attrSortNum: string;
    /* 套餐编号 */
    goodsPackageId: string;
    /* 序号 */
    serialNumber: string;
    /* 套餐名称 */
    packageName: string;
    /* 套餐编码 */
    packageCode: string;
    /* 套餐条形码 */
    barcode: string;
    /* 重量 */
    weight: string;
    /* 套餐主图 */
    mainImageUrl: string;
    /*套餐主图大小  */
    mainImageSize: string;
    /*套餐状态  */
    packageStatus: string;
    /* 市场价 */
    marketPrice: string;
    /* 参考成本价 */
    referPrice: string;
    /* 是否启用客户级别定价 */
    isUseCusLevelPrice: string;
    /* 是否启用客户定价 */
    isUseCusPrice: string;
    /* 价格设置是否同步至其他套餐 */
    isSyncOther: string;
    /* 客户级别定价表ID */
    autoId: string;
    /* 客户级别编号 */
    customerLevelId: string;
    /* 订货价 */
    orderPrice: string;
    /* 起订量 */
    minimum: string;
    /* 限定量 */
    maximum: string;
    /*客户编号  */
    customerId: string;
    /* 商品图册图片路径 */
    imageUrl: string;
    /* 图片大小 */
    imageSize: string;
    /* 商品编号 */
    goodsId: string;
    /* 规格是否变动（包含删除和新增） */
    isSpecification: string;
    /* 标签列表 */
    goodsTagList:GoodsTagListDto[];
    brandList:GoodsBrandListDto[];

}
//商品分类
export class GoodsCategoryListDto{
    /* 公司编号 */
    companyId: string;
    /* 商品分类编号 */
    categoryId: string;
    /* 商品分类名称 */
    categoryName: string;
    /* 层级编号 */
    hierarchyId: string;
    /* 分类层级 */
    categoryLevel: string;
    children: GoodsCategoryListDto[];
    [x: string]: any;
}

//获取公司名称列表
export class CompanyListDto{
    /* 公司编号 */
    companyId: string;
    /* 公司名称 */
    companyName: string;
    /* 公司LOG */
    logoUrl: string;
    /* 登录账户名 */
    loginName: string;
    /* 用户编号 */
    userId: string;
}

/* 搜索历史记录 */
export class SearchHistoryDto{
    searchType?:string // 搜索类型
    keyword?:string // 搜索关键字
}

/**
 * 判断商品名称是否重复
 * @param params
 */
export function isGoodsNameExist (params: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response>({
        url: '/cykjcommodity/goodsGM/isGoodsNameExist',
        method: 'post',
        data: { ...params, ...assignParams() },
        extraParams: { showLoading: false }
    })
}

/**
 * 获取搜索框历史记录
 * @param parameter
 */
export function getSearchHistoryList(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<Array<SearchHistoryDto>>>({
        url: "/cykjbusiness/LQ/getSearchHistoryList",
        method: "post",
        data: { ...parameter, ...assignParams() },
        extraParams: { showLoading: false }
    });
}
/**
 * 获取商品列表
 * @param parameter
 */
export function getGoodsList(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<Ajax.ListData<GoodsListDto>>>({
        url: "/cykjcommodity/GetGoodsInfo/getGoodsList",
        method: "post",
        data: { ...parameter, ...assignParams() },
        extraParams: { showLoading: false }
    });
}


/**
 * 获取商品详情
 * @param parameter
 */
export function getGoodsInfo(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<Ajax.ListData<GoodsInfoDto>>>({
        url: "/cykjcommodity/GetGoodsInfo/getGoodsInfo",
        method: "post",
        data: { ...parameter, ...assignParams() },
    });
}
/**
 * 获取商品分类列表
 * @param parameter
 */
export function getGoodsCategoryList(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<Ajax.ListData<GoodsCategoryListDto>>>({
        url: "/cykjcommodity/shopping/getGoodsCategoryList",
        method: "post",
        data: { ...parameter, ...assignParams() },
    });
}
/**
 * 添加商品分类
 * @param parameter
 */
export function addGoodsCategory(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<Ajax.ListData<GoodsCategoryListDto>>>({
        url: "/cykjcommodity/shopping/addGoodsCategory",
        method: "post",
        data: { ...parameter, ...assignParams() },
    });
}
/**
 * 获取规格信息
 * @param parameter
 */
export function goodsSpecificationList(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<Ajax.ListData<GoodsInfoDto>>>({
        url: "/cykjcommodity/GetGoodsInfo/getGoodsInfo",
        method: "post",
        data: { ...parameter, ...assignParams() },
    });
}
/**
 * 批量设置商品推荐
 * @param params
 */
export function BatchRecommendGoods (params: Parameter) {
    return axiosAPIUrl<Ajax.Response>({
        url: '/cykjcommodity/goodsGM/batchRecommendGoods',
        method: 'post',
        data: { ...params, ...assignParams() }
    })
}
/**
 * 删除商品
 * @param parameter
 */
export function deleteGoods(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<GoodsListDto>>({
        url: "/cykjcommodity/goodsGM/deleteGoods",
        method: "post",
        data: { ...parameter, ...assignParams() },
    });
}

/**
 * 批量上架商品
 * @param parameter
 */
export function batchUpGoods(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<GoodsListDto>>({
        url: "/cykjcommodity/goodsGM/batchUpGoods",
        method: "post",
        data: { ...parameter, ...assignParams() },
    });
}
/**
 * 批量下架商品
 * @param parameter
 */
export function batchDownGoods(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<GoodsListDto>>({
        url: "/cykjcommodity/goodsGM/batchDownGoods",
        method: "post",
        data: { ...parameter, ...assignParams() },
    });
}

/**
 * 获取商品分类
 * @param parameter
 */
export function GetGoodsCategoryList (parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response>({
        url: '/cykjcommodity/shopping/getGoodsCategoryList',
        method: 'post',
        data: { ...parameter, ...assignParams() }
    })
}
/**
 * 批量停用商品
 * @param parameter
 */
export function batchDisableGoods(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<GoodsListDto>>({
        url: "/cykjcommodity/goodsGM/batchDisableGoods",
        method: "post",
        data: { ...parameter, ...assignParams() },
    });
}
/**
 * 批量删除商品
 * @param parameter
 */
export function batchDeleteGoods(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<GoodsListDto>>({
        url: "/cykjcommodity/goodsGM/batchDeleteGoods",
        method: "post",
        data: { ...parameter, ...assignParams() },
    });
}
/**
 * 获取商品品牌列表
 * @param parameter
 */
export function getGoodsBrandList(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<GoodsBrandListDto[]>>({
        url: "/cykjcommodity/shop/getGoodsBrandList",
        method: "post",
        data: { ...parameter, ...assignParams() },
        extraParams: { showLoading: false }
    });
}
/**
 * 获取商品标签列表
 * @param parameter
 */
export function getGoodsTagList(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<{companyId: string, tagList: GoodsTagListDto}>>({
        url: "/cykjcommodity/GoodsTag/getGoodsTagList",
        method: "post",
        data: { ...parameter, ...assignParams()},
        extraParams: { showLoading: false }
    });
}

/**
 * 新增商品
 * @param parameter
 */
export function addGoodsSubmit(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response>({
        url: "/cykjcommodity/goodsGM/addGoodsSubmit",
        method: "post",
        data: { ...parameter, ...assignParams() },
    });
}
/**
 * 修改商品
 * @param parameter
 */
export function editGoodsSubmit(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response>({
        url: "/cykjcommodity/goodsGM/modifyGoodsSubmit",
        method: "post",
        data: { ...parameter, ...assignParams() },
    });
}

/**
 * 新增商品标签
 * @param parameter
 */
export function addGoodsTag(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response>({
        url: "/cykjcommodity/GoodsTag/addGoodsTag",
        method: "post",
        data: { ...parameter, ...assignParams() },
    });
}
/**
 * 修改商品标签
 * @param parameter
 */
export function modifyGoodsTag(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response>({
        url: "/cykjcommodity/GoodsTag/modifyGoodsTag",
        method: "post",
        data: { ...parameter, ...assignParams() },
    });
}
/**
 * 新增商品品牌
 * @param parameter
 */
export function addGoodsBrand(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response>({
        url: "/cykjcommodity/shop/addGoodsBrand",
        method: "post",
        data: { ...parameter, ...assignParams() },
    });
}
/**
 * 修改商品品牌
 * @param parameter
 */
export function modifyGoodsBrand(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response>({
        url: "/cykjcommodity/shop/modifyGoodsBrand",
        method: "post",
        data: { ...parameter, ...assignParams() },
    });
}

/**
 * 获取公司名称列表
 * @param parameter
 */
export function getCompanyList(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response <Ajax.ListData<CompanyListDto>>>({
        url: "/cykjoperation/companyQuery/getCompanyList",
        method: "post",
        data: { ...parameter, ...assignParams() },
    });
}

/**
 * 获取客户级别列表
 * @param parameter
 */
 export function getMerchantsLevelList(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<{ companyId: string, levelList: LevelListDto[] }>>({
        url: "/cykjoperation/merchantsQuery/getMerchantsLevelList",
        method: "post",
        data: {...parameter, ...assignParams()},
        extraParams: { showLoading: false }
    });
}

/**
 * 关键字处理
 * @param parameter
 */
export function manipulationKeyword(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response <Ajax.ListData<CompanyListDto>>>({
        url: "/cykjcommodity/goodsGM/manipulationKeyword",
        method: "post",
        data: { ...parameter, ...assignParams() },
    });
}
